export default "__VITE_ASSET__DL9GL7xu__"